import {
    useBuscarFacturasGraficoDashboard,
    useBuscarAnticposGraficoDashboard, 
    useBuscarNotasCreditoGraficoDashboard, 
    useBuscarNotasDebitoGraficoDashboard, 
    useBuscarOrdenesCompraGraficoDashboard, 
    useBuscarPagosGraficoDashboard,
    useBuscarOrdenesCompraTransitoGraficoDashboard, 
    useBuscarOrdenesCompraLiquidacionGraficoDashboard,
    useBuscarOrdenesCompraEnAlmacenGraficoDashboard,
    useBuscarTasasGraficoDashboard
} from "../../Scripts/Services/cxp-service.js";
import {SelectButton } from 'primereact'
import React from "react";

export const GraficosCxp = () => {
    
    const [cargando, setCargando] = React.useState(true);
    const [where, setWhere] = React.useState({where :{periodo:'mensual'}});
    const {data: facturasGrafico } = useBuscarFacturasGraficoDashboard(where);
    const {data: anticiposGrafico } = useBuscarAnticposGraficoDashboard(where);
    const {data: pagosGrafico } = useBuscarPagosGraficoDashboard(where);
    const {data: ordenesCompraGrafico } = useBuscarOrdenesCompraGraficoDashboard(where);
    const {data: notasDebitoGrafico } = useBuscarNotasDebitoGraficoDashboard(where);
    const {data: notasCreditoGrafico } = useBuscarNotasCreditoGraficoDashboard(where);
    const {data: tasasGrafico} = useBuscarTasasGraficoDashboard(where);
    const {data: ordenesCompraTransito} = useBuscarOrdenesCompraTransitoGraficoDashboard(where);
    const {data: ordenesCompraLiquidacion} = useBuscarOrdenesCompraLiquidacionGraficoDashboard(where);
    const {data: ordenesCompraEnAlmacen} = useBuscarOrdenesCompraEnAlmacenGraficoDashboard(where);

    const facturasGraficoPrevEstus = React.useRef();
    const anticiposGraficoPrevEstus = React.useRef();
    const pagosGraficoGraficoPrevEstus = React.useRef();
    const ordenesCompraGraficoPrevEstus = React.useRef();
    const notasDebitoGraficoPrevEstus = React.useRef();
    const notasCreditoGraficoPrevEstus = React.useRef();
    const tasasGraficoPrevEstus = React.useRef();
    const ordenesCompraTransitoPrevEstus = React.useRef();
    const ordenesCompraLiquidacionPrevEstus = React.useRef();
    const ordenesCompraEnAlmacenPrevEstus = React.useRef();

    const color = ['#3fb1e3', '#91cc75', '#fac858', '#ee6666'];
    const moneda = window.monedaPredeterminada;

    const labelOptions = {
        show: true,
        rotate: 90,
        align: 'left',
        position: 'insideBottom',
        verticalAlign: 'middle',
        color: '#000',
        fontSize: 12,
    }

    const [value, setValue] = React.useState(null);
    const periodos = [
        { name: 'Dario', value: 1 },
        { name: 'Semanal', value: 2 },
        { name: 'Mensual', value: 3 },
        { name: 'Trimestral', value: 4 },
        { name: 'Anual', value: 5 }
    ];
    function m(n, d) {
        //Convertir numero => 3,000,000 a 3M
        const x = Math.floor(Math.log10(Math.abs(n)));
        const suffix = ['','k','M','MM','T','P','E'];
        const magnitude = Math.floor(x / 3);
        const scaled = n / Math.pow(10, magnitude * 3);
        const rounded = Math.round(scaled * Math.pow(10, d)) / Math.pow(10, d);

        return rounded + ' ' + suffix[magnitude];
    }   
    function handleChange(value) {
        localStorage.setItem('periodoGrafico', JSON.stringify(value))
        setValue(value);
        switch(value){
            case 1:
                setWhere({where: {periodo:'diario'}});
                break;
            case 2:
                setWhere({where: {periodo:'semanal'}});
                break;
            case 3:
                setWhere({where: {periodo:'mensual'}});
                break;
            case 4:
                setWhere({where: {periodo:'trimestral'}});
                break;
            case 5:
                setWhere({where: {periodo:'anual'}})
                break;
        }
        setCargando(true);
    }
    function crearDivGrafico(data){
        let dom = document.getElementById('chart_' + data.Titulo);
        if (dom) {
            var chartTemp = echarts.getInstanceByDom(document.getElementById('chart_' + data.Titulo));
            if (chartTemp) {
                chartTemp.dispose();
            }
        } else {
            let chart = document.createElement('div');
            chart.setAttribute('id', 'chart_' + data.Titulo)
            chart.setAttribute('class', 'chart');
            document.getElementById('chart_holder').appendChild(chart);
        }   
    }
    function crearGrafico(data){ 
        crearDivGrafico(data);
        var chartDom = document.getElementById('chart_' + data.Titulo);
        const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
        var options = {
            color: color,
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
                data: ['Promedio', 'Total']
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
            },
            dataset: {
                dimensions: ['periodo', 'Cantidad', 'Promedio', 'Total'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Cantidad: d.Cantidad,
                        Promedio: d.Promedio,
                        Total: d.Monto,
                    }
                })
            },
            xAxis: { type: 'category', },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 9,
                    formatter: function (params) {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`                      
                    }
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series:
                [
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        barGap: 0,
                        barWidth: 0.1
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Total)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            ...labelOptions,
                            formatter: function (params) {
                                return moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(params.value.Promedio)
                            },
                        },
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        }
                    },
                ]
        };
        chart.setOption(options);
    }
    function crearGraficoDeTasas(data) {
        crearDivGrafico(data);
        var chartDom = document.getElementById('chart_' + data.Titulo);

        var myChart = echarts.init(chartDom, null, {
            renderer: 'canvas',
            height: '300',
            width: '630'
        });
        var option;

        option = {
              title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
              },
              tooltip: {
                trigger: 'axis',
                valueFormatter: value => value.toFixed(2) + ' %'
              },
              legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
              },
              dataset: {
                dimensions: ['periodo', 'Cantidad', 'Total', 'Promedio'],
                source: data.Resultados.map((d) => {
                    return {
                        periodo: d.FechaDesc,
                        Cantidad: d.Cantidad,
                        Total: d.Monto,
                        Promedio: d.Promedio,
                    }
                })
            },
              xAxis: { type: 'category', boundaryGap: false, },
              yAxis: { 
                  type: 'value',                     
                  axisLabel: { formatter: '{value} %' }
                },
              series: [
                {
                  name: 'Tasa de Morosidad',
                  type: 'line',
                },
                {
                  name: 'Tasa de Pago',
                  type: 'line',
                },
                {
                  name: 'Tasa de Impagos',
                  type: 'line',
                }
              ]
            };
           myChart.setOption(option);
    }
    function crearGraficodePagos(data){
        crearDivGrafico(data);
        var chartDom = document.getElementById('chart_' + data.Titulo);
        const chart = echarts.init(chartDom,null,{width: '653', height: '300'} );
        var options = {
            color: [
                "#5470c6",
                "#91cc75",
                "#fac858",
                "#ee6666",
                "#73c0de",
                "#3ba272",
                "#fc8452",
                "#9a60b4",
                "#ea7ccc"
            ],
            title: {
                text: data.Titulo,
                left: 'center',
                textStyle: {
                    fontStyle: 'normal',
                    fontWeight: 'bolder',
                    fontFamily: 'sans-serif'
                }
            },
            legend: {
                orient: 'horizontal',
                left: 'center',
                top: 'bottom',
                data: [
                    'Cheques',
                    'Transferencias',
                    'Pagos de Contado',
                  ],
                  selected: {
                    'Promedio de Cheques': false,
                    'Promedio de Transferencias' : false,
                    'Promedio de Pagos de Contado': false,
                    'Cantidad de Cheques' : false,
                    'Cantidad de Transferencias': false,
                    'Cantidad de Pagos de Contado': false
                }
            },
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    type: 'shadow'
                },
            },
            dataset: {
                dimensions: [
                  'periodo',
                  'CantidadCheque',
                  'PromedioCheque',
                  'TotalCheque',
                  'CantidadTransferencias',
                  'PromedioTransferencias',
                  'TotalTransferencias',
                  'Cantidad',
                  'Promedio',
                  'Total',
                ],
                
                source: data.Resultados.flatMap((c, index) => {
                  return c.map((d) => {
                    let dataObj = {
                      periodo: d.FechaDesc,
                    };
              
                    if (index === 0) {
                      dataObj = {
                        ...dataObj,
                        CantidadCheque: d.Cantidad,
                        PromedioCheque: d.Promedio,
                        TotalCheque: d.Monto,
                      };
                    } else if (index === 1) {
                      dataObj = {
                        ...dataObj,
                        CantidadTransferencias: d.Cantidad,
                        PromedioTransferencias: d.Promedio,
                        TotalTransferencias: d.Monto,
                      };
                    } else {
                      dataObj = {
                        ...dataObj,
                        Cantidad: d.Cantidad,
                        Promedio: d.Promedio,
                        Total: d.Monto,
                      };
                    }
                    return dataObj;
                  });
                }),
              },
            xAxis: { type: 'category', },
            yAxis: {
                type: 'value',
                axisLabel: {
                    fontSize: 9,
                    formatter: function (params) {
                        if(params >= 1000) return `${moneda} ${m(params,1)}`
                        else return `${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params)}`                      
                    }
                },
            },
            series:
                [
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Cantidad de Cheques',
                        barGap: 0,
                        barWidth: '0%',
                        stack: 'cantidad',
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Promedio de Cheques',
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        },
                        barWidth: '0%',
                        stack: 'promedio',
                        
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Cheques',
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        },
                        stack: 'total',
                        tooltip: {                            
                            formatter: function(params){
                                let totalGeneral = (params?.value?.TotalCheque ?? 0) + (params?.value?.Total ?? 0) + (params?.value?.TotalTransferencias ?? 0);
                                return tooltipGraficoDePagosFormatter('Cheques', params.color, params.value.periodo ,params.value.CantidadCheque, params.value.PromedioCheque, params.value.TotalCheque, totalGeneral);
                            }
                        },
                        color: '#91cc75'
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Cantidad de Transferencias',
                        barGap: 0,
                        barWidth: '0%',
                        stack: 'cantidad'
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Promedio de Transferencias',
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value),
                        },
                        barWidth: '0%',
                        stack: 'promedio'
                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                            tooltip: {                            
                                formatter: function(params){
                                    let totalGeneral = (params?.value?.TotalCheque ?? 0) + (params?.value?.Total ?? 0) + (params?.value?.TotalTransferencias ?? 0);
                                    return tooltipGraficoDePagosFormatter('Transferencias', params.color, params.value.periodo ,params.value.CantidadTransferencias, params.value.PromedioTransferencias, params.value.TotalTransferencias, totalGeneral);
                                }
                            },
                        name: 'Transferencias',
                        stack: 'total',
                        color: '#fac858'

                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Cantidad de Pagos de Contado',
                        barGap: 0,
                        barWidth: '0%',
                        stack: 'cantidad'

                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Promedio de Pagos de Contado',
                        tooltip: {
                            valueFormatter: value => moneda + " " + Citrus.Convert.toCurrencyNoSimbolo(value)
                        },
                        barWidth: '0%',
                        stack: 'promedio'


                    },
                    {
                        type: 'bar',
                        emphasis: {
                            focus: 'series'
                        },
                        label: {
                            show: false,
                        },
                        name: 'Pagos de Contado',
                        tooltip: {                            
                            formatter: function(params){
                                let totalGeneral = (params?.value?.TotalCheque ?? 0) + (params?.value?.Total ?? 0) + (params?.value?.TotalTransferencias ?? 0);
                                return tooltipGraficoDePagosFormatter('Pagos de Contado', params.color ,params.value.periodo ,params.value.Cantidad, params.value.Promedio, params.value.Total, totalGeneral);
                            }
                        },
                        stack: 'total',
                        color: '#3fb1e3'
                    },
                ]
        };
        options.dataset.source.sort((a, b) => {
            // ordernar por la propiedad de periodo
            const dateA = new Date(a.periodo.split("/").reverse().join("/"));
            const dateB = new Date(b.periodo.split("/").reverse().join("/"));        
            return dateA - dateB;
        });
        const unirDatos = options.dataset.source.reduce((acc, obj) => {
            const existing = acc.find(item => item.periodo === obj.periodo);          
            if (existing) {
              Object.assign(existing, obj);
            } else {
              acc.push(obj);
            }          
            return acc;
          }, []);
        options.dataset.source = unirDatos
        chart.setOption(options);
    }
    function tooltipGraficoDePagosFormatter(tipoPago, Color, periodo, cantidad, promedio,total, totalGeneral){
        return `
        <div style="margin: 0px 0 0;line-height:1;">
            <div style="margin: 10px 0 0;line-height:1;">
            <div>    
                <span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${Color};"></span>
                ${tipoPago}
                <div style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${periodo}</div>
                
                <div style="margin:10px 0 0">
                    <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">Cantidad:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${cantidad}</span>
                </div>            
                
                <div style="margin:10px 0 0">
                    <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">Promedio:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(promedio)}</span>
                </div>

                <div style="margin:10px 0 0">
                    <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">Total:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(total)}</span>
                </div>
                <hr>
                <div style="margin:10px 0 0">
                <span style="font-size:14px;color:#666;font-weight:400;margin-left:2px">Total Pagos:</span>
                <span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(totalGeneral)}</span>
            </div>
            </div>
        </div>`    
    }

React.useEffect(() => {
if(localStorage.getItem('periodoGrafico')){
    setValue(JSON.parse(localStorage.getItem('periodoGrafico')))
}else {
    setValue(3);
}
if(localStorage.getItem('facturasGrafico')){
    crearGrafico(JSON.parse(localStorage.getItem('facturasGrafico')));
    facturasGraficoPrevEstus.current = true;
}
if(localStorage.getItem('anticiposGrafico')){
    crearGrafico(JSON.parse(localStorage.getItem('anticiposGrafico')));
    anticiposGraficoPrevEstus.current = true;
}
if(localStorage.getItem('pagosGrafico')){
    crearGraficodePagos(JSON.parse(localStorage.getItem('pagosGrafico')));
    pagosGraficoGraficoPrevEstus.current = true;
}
if(localStorage.getItem('ordenesCompraGrafico')){
    crearGrafico(JSON.parse(localStorage.getItem('ordenesCompraGrafico')));
    ordenesCompraGraficoPrevEstus.current = true;
}
if(localStorage.getItem('notasDebitoGrafico')){
    crearGrafico(JSON.parse(localStorage.getItem('notasDebitoGrafico')));
    notasDebitoGraficoPrevEstus.current = true;
}
if(localStorage.getItem('notasCreditoGrafico')){
    crearGrafico(JSON.parse(localStorage.getItem('notasCreditoGrafico')));
    notasCreditoGraficoPrevEstus.current = true;
}
if(localStorage.getItem('tasasGrafico')){
    crearGraficoDeTasas(JSON.parse(localStorage.getItem('tasasGrafico')));
    tasasGraficoPrevEstus.current = true;
}
if(localStorage.getItem('ordenesCompraTransito')){
    crearGrafico(JSON.parse(localStorage.getItem('ordenesCompraTransito')));
    ordenesCompraTransitoPrevEstus.current = true;
}
if(localStorage.getItem('ordenesCompraLiquidacion')){
    crearGrafico(JSON.parse(localStorage.getItem('ordenesCompraLiquidacion')));
    ordenesCompraLiquidacionPrevEstus.current = true;
}
if(localStorage.getItem('ordenesCompraEnAlmacen')){
    crearGrafico(JSON.parse(localStorage.getItem('ordenesCompraEnAlmacen')));
    ordenesCompraEnAlmacenPrevEstus.current = true;
}
},[])

    React.useEffect(() => {
        if(facturasGrafico) {
            if(facturasGraficoPrevEstus.current){
                facturasGraficoPrevEstus.current = false;
                return;
            }
            crearGrafico(facturasGrafico);
            localStorage.setItem('facturasGrafico',JSON.stringify(facturasGrafico));
        }
    },[facturasGrafico])
    React.useEffect(() => {
        if(anticiposGrafico) {
            if(anticiposGraficoPrevEstus.current){
                anticiposGraficoPrevEstus.current = false;
                return;
            }
            crearGrafico(anticiposGrafico);
            localStorage.setItem('anticiposGrafico',JSON.stringify(anticiposGrafico));
        }
    }, [anticiposGrafico])
    React.useEffect(() => {
        if(pagosGrafico) {
            if(pagosGraficoGraficoPrevEstus.current){
                pagosGraficoGraficoPrevEstus.current = false;
                return;
            }
            crearGraficodePagos(pagosGrafico);
            localStorage.setItem('pagosGrafico',JSON.stringify(pagosGrafico));
        }
    },[pagosGrafico])
    React.useEffect(() => {
        if(ordenesCompraGrafico) {
            if(ordenesCompraGraficoPrevEstus.current){
                ordenesCompraGraficoPrevEstus.current = false;
                return;
            }
            crearGrafico(ordenesCompraGrafico);
            localStorage.setItem('ordenesCompraGrafico',JSON.stringify(ordenesCompraGrafico));
        }
    }, [ordenesCompraGrafico])
    React.useEffect(() => {
        if(notasDebitoGrafico) {
            if(notasDebitoGraficoPrevEstus.current){
                notasDebitoGraficoPrevEstus.current = false;
                return;
            }
            crearGrafico(notasDebitoGrafico);
            localStorage.setItem('notasDebitoGrafico',JSON.stringify(notasDebitoGrafico));
        }
    }, [notasDebitoGrafico])
    React.useEffect(() => {
        if(notasCreditoGrafico) {
            if(notasCreditoGraficoPrevEstus.current){
                notasCreditoGraficoPrevEstus.current = false;
                return;
            }
            crearGrafico(notasCreditoGrafico);
            localStorage.setItem('notasCreditoGrafico',JSON.stringify(notasCreditoGrafico));
        }
    }, [notasCreditoGrafico])
    React.useEffect(() => {
        if(tasasGrafico) {
            if(tasasGraficoPrevEstus.current){
                tasasGraficoPrevEstus.current = false;
                return;
            }
            crearGraficoDeTasas(tasasGrafico);
            localStorage.setItem('tasasGrafico',JSON.stringify(tasasGrafico));
        }
    }, [tasasGrafico])
    React.useEffect(() => {
        if(ordenesCompraTransito) {
            if(ordenesCompraTransitoPrevEstus.current){
                ordenesCompraTransitoPrevEstus.current = false;
                return;
            }
            crearGrafico(ordenesCompraTransito);
            localStorage.setItem('ordenesCompraTransito',JSON.stringify(ordenesCompraTransito));
        }
    }, [ordenesCompraTransito])
    React.useEffect(() => {
        if(ordenesCompraLiquidacion) {
            if(ordenesCompraLiquidacionPrevEstus.current){
                ordenesCompraLiquidacionPrevEstus.current = false;
                return;
            }
            crearGrafico(ordenesCompraLiquidacion);
            localStorage.setItem('ordenesCompraLiquidacion',JSON.stringify(ordenesCompraLiquidacion));
        }
    }, [ordenesCompraLiquidacion])
    React.useEffect(() => {
        if(ordenesCompraEnAlmacen) {
            if(ordenesCompraEnAlmacenPrevEstus.current){
                ordenesCompraEnAlmacenPrevEstus.current = false;
                return;
            }
            crearGrafico(ordenesCompraEnAlmacen);
            localStorage.setItem('ordenesCompraEnAlmacen',JSON.stringify(ordenesCompraEnAlmacen));
        }
    }, [ordenesCompraEnAlmacen])
    return (
        <div>
            <SelectButton 
            value={value}
            onChange={(e) => handleChange(e.value)}
            optionLabel='name'
            options= {periodos}
            style={{    
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '10px',
                padding: '12px',
                flexFlow: 'columnWrap',
                aligItems: 'center',}}
            />  
            <div id="chart_holder" class="card_row">
            </div>
        </div>        
    )
}